export default [
  {
    name: 'getSysAbout',
    method: 'GET',
    path: '/vue/system/sysabout-get'
  },
  {
    name: 'getSysAboutPage',
    method: 'POST',
    path: '/vue/system/sysabout-page'
  },
  {
    name: 'saveSysAbout',
    method: 'POST',
    path: '/vue/system/sysabout-save'
  },
  {
    name: 'deleteSysAbout',
    method: 'POST',
    path: '/vue/system/sysabout-delete'
  }
];
